import React from 'react'
import { translate } from '../../utils/useful'

class TableLicenseInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        return (
            <div className="w-100 h-100 flexc text-start">
                {this.props.data ? (
                    <div className='flexc br-20 px-1 py-1' style={{ background: 'rgb(251, 240, 207)' }}>
                        <img src="/assets/icons/applets/general/diamond-award.png" height={20} alt="" />
                        <p className="mld-2 text-bold mrd-3" style={{ color: 'rgb(210, 140, 10)', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{translate("Licensed")}</p>
                    </div>
                ) : (
                    <p>{' '}</p>
                )}
            </div>
        )
    }
}

export default TableLicenseInput;